import { USER_TYPE_AGENT } from "@/constants/common";

export function isMessageComplianceActive(appConfig, userType) {
  if (!appConfig) return false;
  if (userType !== USER_TYPE_AGENT) return false;
  if (!appConfig.flags?.mlsAgentEditor) return false;
  const block = appConfig.tenant?.messageCompliance;
  if (!block || block.enabled === false) return false;
  return true;
}

export function getTenantComplianceConfig(appConfig) {
  return appConfig?.tenant?.messageCompliance || null;
}

export function summarizeViolations(violations) {
  if (!Array.isArray(violations) || violations.length === 0) {
    return { byCategory: {}, blockCount: 0, warnCount: 0 };
  }
  const byCategory = {};
  let blockCount = 0;
  let warnCount = 0;
  violations.forEach((v) => {
    const key = v.category || "other";
    if (!byCategory[key]) byCategory[key] = [];
    byCategory[key].push(v);
    if (v.severity === "block") blockCount += 1;
    else if (v.severity === "warn") warnCount += 1;
  });
  return { byCategory, blockCount, warnCount };
}

export const COMPLIANCE_SURFACE = {
  WANT_AD_INTRO: "wantAdIntro",
  DIRECT_INBOX: "directInbox",
};

export const COMPLIANCE_DEBOUNCE_MS = 800;
